import { createSlice } from "@reduxjs/toolkit";
import { getWishlistProducts } from "../../reduxApi/website/WishlistApi";
import { deleteFromWishlist } from "../../api/website/AddtoWishlistApi";

const WishlistSlice = createSlice({
  name: "Wishlist",
  initialState: {
    status: "idle",
    wishlistCount: 0,
    wishlist: [],
    error: null,
  },
  reducers: {
    addToWishlistLocal: (state, action) => {
      const exists = state.wishlist.find(
        (item) => item.wishLists?.wishListItem === action.payload.wishListItem
      );
      if (!exists) {
        state.wishlist = [...state.wishlist, { wishLists: action.payload }];
        state.wishlistCount += 1;
      }
    },
    removeFromWishlistLocal: (state, action) => {
      state.wishlist = state.wishlist.filter(
        (item) => item.wishLists?.ROWID !== action.payload
      );
      state.wishlistCount = state.wishlist.length;
    },
    clearWishlist: (state) => {
      state.wishlist = [];
      state.wishlistCount = 0;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWishlistProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getWishlistProducts.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const data = action.payload?.data;
        // Normalize: API returns {wishlist: [...]} or directly [...] or null
        if (Array.isArray(data)) {
          state.wishlist = data;
        } else if (data && Array.isArray(data.wishlist)) {
          state.wishlist = data.wishlist;
        } else {
          state.wishlist = [];
        }
        state.wishlistCount = state.wishlist.length;
      })
      .addCase(getWishlistProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Failed to fetch wishlist";
      });

    builder.addCase(deleteFromWishlist.fulfilled, (state, action) => {
      const rowId = action.meta.arg;
      state.wishlist = state.wishlist.filter(
        (item) => item.wishLists?.ROWID !== rowId
      );
      state.wishlistCount = state.wishlist.length;
    });
  },
});

export const {
  addToWishlistLocal,
  removeFromWishlistLocal,
  clearWishlist,
} = WishlistSlice.actions;

export default WishlistSlice.reducer;
